import { useEffect, useState } from "react"
import { TextField } from "@mui/material"

export const UoM = ({ params, listOfUoM }) => {

    const [uom, setUom] = useState(params.value)
    const [item, setItem] = useState([])

    useEffect(() => {
        setUom(params.value)
    }, [params.row.unit_of_measure_id])

    useEffect(() => {
        if (uom) {
            const item = listOfUoM.find(i => i.id == uom)
            setItem(item)
        }
    }, [uom, listOfUoM])

    return (

        <TextField type="text" variant='standard' disabled className='w-full mb-5 px-0 pt-0' value={item?.code || []} />
    )
}
